import API from './axios.js';

export const getDisplayBoardData = () => API.get('case-dashboard');
export const getDisplayBoardDataByUser = (userId) => API.get(`case-dashboard/by-user/${userId}`);

export const getAppealData = () => API.get('case-dashboard/appeal');
export const getAppealDataByUser = (userId) => API.get(`case-dashboard/appeal/by-user-id/${userId}`);

